<template>
    <app-layout title="Gebruikers">
        <template #header>
            <page-title :title="'Gebruikers - ' + user_info.name + ': tokens'" />
        </template>

        <template #pageContent>
        <div id="tokens" class="border-solid border border-slate-300 rounded m-4 mx-auto w-auto md:w-3/4 lg:w-1/2" >
            <div class="border-solid border-b border-slate-300 bg-gray-100 flex" >
                <p class="pt-2 pl-2">Token toevoegen</p>
            </div>
            <div class="m-4">
                <Form @submit="createToken">
                        <Input label="Gebruikersnaam" name="username" disabled v-model="user_info.username" layout="vertical"/>
                        <Input label="Token" name="token" type="text" required v-model="form.token" layout="vertical"/>
                        <div class="my-3">
                            <Label for="permissions" label="Rechten" class="flex-none" id="label_permissions"/>
                            <Multiselect
                                v-model="form.permissions"
                                :options="permissions"
                                mode="tags"
                                id="permissions"
                                :searchable="true"
                                placeholder="selecteer een recht"
                                :closeOnSelect="false"
                            />
                            <Error :error="form.errors.permissions" v-if="form.errors.permissions" />
                        </div>

                        <Button text="Token aanmaken" buttonType="submit" buttonClass="save" class="mt-auto"/>
                </Form>
            </div>
        </div>
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'
import Table from '@/Components/Table.vue'
import Td from '@/Components/Td.vue'
import Th from '@/Components/Th.vue'
import Button from '@/Components/Button.vue'
import Modal from '@/Components/Modal.vue'
import Label from '@/Components/Label.vue'
import Input from '@/Components/Input.vue'
import Badge from '@/Components/Badge.vue'
import Select from '@/Components/Select.vue'
import Form from '@/Components/Form.vue'
import Error from '@/Components/Error.vue'

import { Link, useForm } from '@inertiajs/inertia-vue3';
import store from '@/store'
import moment from "moment";
import Multiselect from '@vueform/multiselect'

export default {
    components: {
        AppLayout,
        PageTitle,
        Link, Table,
        Td,
        Th,
        Button,
        Modal,
        Input,
        Badge,
        Select,
        Form,
        Multiselect,
        Label,
        Error
    },
    props:[
        'user_info',
        'permissions',
        'default_permissions'
    ],
    data() {
        return {}
    },
    setup (props){
        let form = useForm({
            'token':'',
            'permissions':props.default_permissions
        })
        function createToken(){
            form.post('/admin/users/'+ props.user_info.id + '/tokens')
        }
        return {
            state: store.state,
            ...store,
            createToken,
            form
        }
    },
    created: function () {
        this.moment = moment;
    },
    computed: {
    },
}

</script>
